import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './Home';
import CoursePreferences from './CoursePreferences';
import FeatureCourses from './FeatureCourses';
import ReportsTabsWrapperContainer from './ReportsTabs';
import { StudentActivityWrapper } from './StudentActivity';
import { OverviewWidgetWrapper } from './OverviewWidget';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/courses/:courseId/student-activity',
    element: <StudentActivityWrapper />,
  },
  {
    path: '/courses/:courseId/overview',
    element: <OverviewWidgetWrapper />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/feature-courses',
    element: <FeatureCourses />,
  },
  {
    path: '/course-preferences',
    element: <CoursePreferences />,
  },
  {
    path: '/courses/:courseId/reports',
    element: <ReportsTabsWrapperContainer />,
  },
  // Report type route
  {
    path: '/courses/:courseId/reports/type/:reportType',
    element: <ReportsTabsWrapperContainer />,
  },
  // Report item route
  {
    path: '/courses/:courseId/reports/type/:reportType/:itemId',
    element: <ReportsTabsWrapperContainer />,
  },
  // Report sub-item route
  {
    path: '/courses/:courseId/reports/type/:reportType/:itemId/:subItemId',
    element: <ReportsTabsWrapperContainer />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
